<ion-avatar class="app-avatar" [style.--avatar-size.px]="resolvedSize()">
	@if (src()) {
		<img
			class="app-avatar__img"
			[ngSrc]="src()!"
			[alt]="alt()"
			[width]="resolvedSize()"
			[height]="resolvedSize()"
			[priority]="priority()"
		/>
	} @else if (initials()) {
		<span class="app-avatar__initials">{{ initials() }}</span>
	}
	@if (showStatus()) {
		<span class="app-avatar__status" [ngClass]="'is-' + status()"></span>
	}
	<ng-content select="[appAvatarBadge]"></ng-content>
</ion-avatar>
